var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeChevronDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 2.46967C5.76256 2.17678 6.23744 2.17678 6.53033 2.46967L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L6.53033 21.5303C6.23744 21.8232 5.76256 21.8232 5.46967 21.5303C5.17678 21.2374 5.17678 20.7626 5.46967 20.4697L13.9393 12L5.46967 3.53033C5.17678 3.23744 5.17678 2.76256 5.46967 2.46967Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 2.46967C11.7626 2.17678 12.2374 2.17678 12.5303 2.46967L21.5303 11.4697C21.8232 11.7626 21.8232 12.2374 21.5303 12.5303L12.5303 21.5303C12.2374 21.8232 11.7626 21.8232 11.4697 21.5303C11.1768 21.2374 11.1768 20.7626 11.4697 20.4697L19.9393 12L11.4697 3.53033C11.1768 3.23744 11.1768 2.76256 11.4697 2.46967Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeChevronDoubleRight);
export default __webpack_public_path__ + "static/media/loree-chevron-double-right.bc5106e14b4ea334f0b53c793ea955ca.svg";
export { ForwardRef as ReactComponent };